module.exports = __webpack_public_path__ + "static/media/measurement_img.ac0a9b86.png";